<div class="dashboard">
    <app-counts></app-counts>
    <app-projectlist></app-projectlist>
</div>
